<!--重消订单-->
<template>
<div>
  <app-breadcrumb />
  <div class="page-container recharge-manage">
    <div v-if="activeIndex === 0">
      <el-form label-width="130px">
        <el-row :gutter="20">
          <el-col :md="8" :lg="8" :xl="8">
            <el-form-item size="mini"  :label="$t('miMember.memberNo')">
              <el-input :class="{ 'disabled_remove_css': memberNoDisabled}" :disabled="memberNoDisabled" v-model.trim="memberNo" clearable :placeholder="$t('')" @blur="getAgentno()" />
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <p :class="{ 'account_name_css': account_name_show}" style="color:#538E0D; font-weight:bold; line-height: 4px;">{{ listQuery.accountName }}</p>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center; margin-bottom: 10px">
  <!--      下一步-->
        <el-button size="mini" :disabled="oneNextIf" :loading="btnloading" type="success" icon="el-icon-right" @click="buttonnext">{{ $t('button.next') }}</el-button>
  <!--      取消-->
        <el-button size="mini" :loading="btnloading" type="danger" icon="el-icon-close" @click="buttoncancel">{{ $t('operation.button.cancel') }}</el-button>
      </div>
    </div>
    <div v-if="activeIndex === 1">
      <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
      <el-form label-width="130px" :model="listQuery1">
<!--        收货人姓名-->
        <el-form-item size="mini" style="width: 400px" :label="$t('PoOrder.recName')" :rules="{ required: true, message: this.$t('po.setInfo'), trigger: ['blur', 'change'] }">
          <el-input v-model.trim="listQuery1.name" clearable :placeholder="$t('')"  />
        </el-form-item>
        <!--        联系电话-->
        <el-form-item size="mini" style="width: 400px" :label="$t('sysCompany.phone')" :rules="{ required: true, message: this.$t('po.setInfo'), trigger: ['blur', 'change'] }">
          <el-input v-model.trim="listQuery1.mobile" clearable :placeholder="$t('')"  />
        </el-form-item>
        <!--        邮编-->
        <el-form-item v-if="listQuery1.recType === '6' " size="mini" style="width: 400px" :label="$t('poscore.zip')" :rules="{ required: true, message: this.$t('po.setInfo'), trigger: ['blur', 'change'] }">
          <el-input v-model.trim="listQuery1.zipCode" clearable :placeholder="$t('')"  />
        </el-form-item>
<!--        收货地址-->
        <el-form-item :label="$t('ssCustomer.saddress')">
          <el-radio v-model="listQuery1.recType" label="4">{{this.$t('pick.up.from.franchise')}}:{{listQuery.agentNo }} - {{ listQuery.name}}</el-radio>
          <br v-show="this.companyCode!=='MY'">
          <el-radio v-show="this.companyCode!=='MY'" v-model="listQuery1.recType" label="5">{{this.$t('pick.up.from.branch.office')}}</el-radio>
          <br>
          <el-radio v-model="listQuery1.recType" label="6">{{this.$t('send.by.post')}}：
<!--            国-->
            <el-select size="mini" style="width: 160px" v-model="listQuery1.country" clearable :placeholder="$t('please.select.country.or.region')" @change="getProvince">
              <el-option value="" />
              <el-option  v-for="role in country" :key="role.regionCode" :label="(role.regionName)" :value="role.regionCode"  />
            </el-select>
<!--            省-->
            <el-select size="mini" v-loading="sltloading" style="width: 160px" v-model="listQuery1.province" clearable :placeholder="$t('please.select.province')" @change="getcity">
              <el-option value="" />
              <el-option v-for="role in province" :key="role.regionCode" :label="(role.regionName)" :value="role.regionCode" />
            </el-select>
<!--            市-->
            <el-select size="mini" v-loading="sltloading" style="width: 160px" v-model="listQuery1.city" clearable :placeholder="$t('please.select.city')" @change="getdistrict">
              <el-option value="" />
              <el-option v-for="role in city" :key="role.regionCode" :label="(role.regionName)" :value="role.regionCode" />
            </el-select>
<!--            县-->
            <el-select size="mini" v-loading="sltloading" style="width: 160px" v-model="listQuery1.district" clearable :placeholder="$t('please.select.district.or.county')">
              <el-option value="" />
              <el-option v-for="role in district" :key="role.regionCode" :label="(role.regionName)" :value="role.regionCode" />
            </el-select>
          </el-radio>
          <br>
<!--          详细地址-->
          <el-form-item size="mini" style="width: 400px" :label="$t('miAgent.storeAddr')">
            <el-input v-model.trim="listQuery1.recAddr" clearable :placeholder="$t('')"  />
          </el-form-item>
        </el-form-item>
      </el-form>
      <div style="text-align: center; margin-bottom: 10px">
        <!--      上一步-->
        <el-button size="mini" :loading="btnloading" type="success" icon="el-icon-back" @click="buttonprevious">{{ $t('button.previous') }}</el-button>
        <!--      下一步-->
        <el-button size="mini" :loading="btnloading" type="success" icon="el-icon-right" @click="buttonnext1">{{ $t('button.next') }}</el-button>
        <!--      取消-->
        <el-button size="mini" :loading="btnloading" type="danger" icon="el-icon-close" @click="buttoncancel1">{{ $t('operation.button.cancel') }}</el-button>
      </div>
    </div>
    <div v-if="activeIndex === 2">
      <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
      <el-form label-width="130px">
        <!--       经销商编号-->
        <el-form-item :label="$t('miMember.memberNo')">
          {{listQuery2.memberNo}}
        </el-form-item>
<!--        备注-->
        <el-form-item :label="$t('Common.remark')">
          <el-input style="width: 400px" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="listQuery2.remark"></el-input>
        </el-form-item>
      </el-form>
      <h3 style="color: #b3640d">{{ $t('mall.ProductsList') }}</h3>
      <p style="color:#538E0D; font-size:14px; font-weight:bold;">{{$t('busi.finance.amount')}} <span  style="color:#F00; font-size:14px; font-weight:bold;">{{totalfA}}</span> FV <span  style="color:#F00; font-size:14px; font-weight:bold;">{{totalFv}}</span></p>
      <el-table
          :key="tableKey"
          height="500"
          v-loading="listLoading"
          :data="list"
          border
          size="mini"
          fit
          highlight-current-row
          style="width: 100%;"
      >
        <!--     预览 -->
        <!--<el-table-column :label="$t('button.preview')" prop="photoName" align="center" />-->
        <!--     商品编码(旧) -->
        <el-table-column :label="$t('Old_goodsCode')" prop="oldcode" align="center" />
        <!--      商品编码-->
        <el-table-column :label="$t('BiGoods.goodsCode')" prop="goodscode" align="center" />
        <!--      商品名称-->
        <el-table-column :label="$t('BiGoods.name')" prop="name" align="center" />
        <!--      价格-->
        <el-table-column :label="$t('pd.price')" prop="standardPrice" align="center" />
        <!--      积分-->
        <el-table-column :label="$t('busi.direct.sale_points')" prop="standardPv" align="center" />
        <!--      可用库存量-->
        <el-table-column :label="$t('stStock.validQty')" prop="validQty" align="center" />
        <!--      购买数量-->
        <el-table-column :label="$t('Common.buyNumber')" prop="buyQty" align="center" >
          <template v-slot="{row}">
            <el-input v-model.number="row.buyQty"  />
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
        <!--      上一步-->
        <el-button size="mini" :loading="btnloading" type="success" icon="el-icon-back" @click="buttonprevious2">{{ $t('button.previous') }}</el-button>
        <!--      下一步-->
        <el-button size="mini" :loading="btnloading" type="success" icon="el-icon-right" @click="buttonnext2">{{ $t('button.next') }}</el-button>
        <!--      取消-->
        <el-button size="mini" :loading="btnloading" type="danger" icon="el-icon-close" @click="buttoncancel2">{{ $t('operation.button.cancel') }}</el-button>
      </div>
    </div>
    <div v-if="activeIndex === 3">
        <el-form label-width="150px">
<!--          支付信息-->
          <h3 style="color: #b3640d">{{ $t('title.payment.info') }}</h3>
<!--         商品总金额 -->
          <el-form-item :label="$t('poAssistMemberOrder.productAmount')">
            {{listQuery3.totalAmount}}
          </el-form-item>
          <!--       物流费   -->
          <el-form-item :label="$t('busi.JPorder.yf')">
            {{0}}
          </el-form-item>
          <!--          合计-->
          <el-form-item :label="$t('bdSendEfuboBonusDetail.amtCount')">
            {{listQuery3.totalLocIn}}
          </el-form-item>
<!--         支付密码 -->
          <el-form-item size="mini" style="width: 400px"  :label="$t('please.input.your.pay.password')" :rules="{ required: true, message: this.$t('po.setInfo'), trigger: ['blur', 'change'] }">
            <el-input v-model.trim="listQuery3.payPassword" show-password clearable :placeholder="$t('')"  />
          </el-form-item>
        </el-form>
      <table>
        <thead>
        <tr>
          <th>{{ $t('Old_goodsCode') }}</th>
          <th>{{ $t('BiGoods.goodsCode') }}</th>
          <th>{{ $t('BiGoods.name') }}</th>
          <th>{{ $t('pd.price') }}</th>
          <th>{{ $t('busi.direct.sale_points') }}</th>
          <th>{{ $t('Common.buyNumber') }}</th>
          <th>{{ $t('order.price.total') }}</th>
          <th>{{ $t('order.pv.total') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="i in list3" :key="i.id">
          <td>{{ i.oldcode }}</td>
          <td>{{ i.goodscode }}</td>
          <td>{{ i.name }}</td>
          <td>{{ i.standardPrice }}</td>
          <td>{{ i.standardPv }}</td>
          <td>{{ i.buyQty }}</td>
          <td>{{ i.standardPrice * i.buyQty }}</td>
          <td>{{ i.standardPv * i.buyQty }}</td>
        </tr>
        <tr>
          <td>{{ $t('poOrder.amtCount') }}</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td>{{ buyQty }}</td>
          <td>{{ totalfA }}</td>
          <td>{{ totalFv }}</td>
        </tr>
        </tbody>
      </table>
      <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
        <!--        上一步-->
        <el-button size="mini" :loading="btnloading" type="success" icon="el-icon-back" @click="buttonprevious3">{{ $t('button.previous') }}</el-button>
        <!--        提交-->
        <el-button size="mini" :loading="btnloading" type="success" icon="el-icon-check" @click="titlesubmit">{{ $t('title.submit') }}</el-button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {mapGetters} from "vuex";
import {getAlRegionsByCode, getLevel1AlRegions, miMemberInfo} from "@/api/member"
import {goodsListCXByMember, saveCX} from "@/api/ay-business-manager/cancelorderagain"

export default {
  name: "CancelorderAgain",
  data(){
    return{
      memberNoDisabled: true,
      account_name_show: false,
      oneNextIf: false,
      activeIndex:0,
      memberNo:null,
      listQuery:{
        accountName: null
      },
      listQuerydata:{},
      listQuery1:{
        recType:'6',
        zipCode:null,
        recAddr:null,
        name:null,
        mobile:null
      },
      listQuery2:{},
      listQuery3:{},
      list3:[],
      tableKey:0,
      listLoading:false,
      list:[],
      btnloading:false,
      open:false,
    //  地区
      sltloading:false,
      country:null,
      province:null,
      city:null,
      district:null
    }
  },
  computed:{
    ...mapGetters([
      'userCode',
      'companyCode',
      'isAgent'
    ]),
    totalfA() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.standardPrice * cur.buyQty + acc
      }, 0).toFixed(2)
    },
    totalFv() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.standardPv * cur.buyQty + acc
      }, 0).toFixed(2)
    },
    buyQty(){
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc,cur) =>{
        return cur.buyQty + acc
      }, 0)
    }
  },
  created() {
    this.getAgentno()
    this.getCountry()
  },
  methods:{
    //国
    getCountry(){
      getLevel1AlRegions().then(res=>{
        this.country = res.data
      }).catch(err=>{
        console.error(err)
      })
    },
    //省
    getProvince(){
      if(!this.listQuery1.country){
        this.listQuery1.province = null
        this.listQuery1.city = null
        this.listQuery1.district = null
      }else {
        this.sltloading = true
        getAlRegionsByCode({'regionCode':this.listQuery1.country}).then(res=>{
          this.listQuery1.province = null
          this.listQuery1.city = null
          this.listQuery1.district = null
          this.province = res.data
          this.sltloading = false
        }).catch(err=>{
          this.sltloading = false
          console.error(err)
        })
      }
    },
    //市
    getcity(){
      this.sltloading = true
      getAlRegionsByCode({'regionCode':this.listQuery1.province}).then(res=>{
        this.listQuery1.city = null
        this.listQuery1.district = null
        this.city = res.data
        this.sltloading = false
      }).catch(err=>{
        this.sltloading = false
        console.error(err)
      })
    },
    //区
    getdistrict(){
      this.sltloading = true
      getAlRegionsByCode({'regionCode':this.listQuery1.city}).then(res=>{
        this.district = res.data
        this.sltloading = false
      }).catch(err=>{
        this.sltloading = false
        console.error(err)
      })
    },
    getAgentno(){
      if (this.isAgent) {
        this.memberNoDisabled = false
        // this.memberNo = ''
        if (this.memberNo) {
          miMemberInfo({'memberNo': this.memberNo}).then(res => {
            this.listQuerydata = res.data
            this.listQuery.accountName = res.data.name
            this.listQuery.agentNo = res.data.agentNo
            this.listQuery.name = res.data.agentName
            this.listQuery2.name = res.data.name
            this.btnloading = false
            this.open = true
            this.oneNextIf = false
            this.account_name_show = false
          }).catch(err => {
            this.listQuery.accountName = ''
            this.account_name_show = true
            this.oneNextIf = true
            this.btnloading = false
            console.error(err)
          })
        } else {
          this.oneNextIf = true
          this.listQuery.accountName = ''
          this.account_name_show = false
        }
      } else {
        this.memberNoDisabled = true
        this.memberNo = this.userCode
        miMemberInfo({'memberNo': this.memberNo}).then(res => {
          this.listQuerydata = res.data
          this.listQuery.accountName = res.data.name
          this.listQuery.agentNo = res.data.agentNo
          this.listQuery.name = res.data.agentName
          this.listQuery2.name = res.data.name
          this.btnloading = false
          this.open = true
          this.oneNextIf = false
        }).catch(() => {
          this.btnloading = false
        })
      }
    },
    buttonnext(){
      if(this.open ===  true){
         if (this.companyCode === 'IN' && this.isAgent) {
           this.listQuery2.memberNo = this.memberNo
           goodsListCXByMember({'memberNo':this.memberNo}).then(res=>{
             this.list = res.data
             this.listQuery1.recType = '1'
             this.btnloading = false
             this.activeIndex = 2
           }).catch(err=>{
             console.error(err)
           })
        } else {
          this.activeIndex = 1
          this.listQuery1.name = this.listQuerydata.name
          this.listQuery1.mobile = this.listQuerydata.mobile
          this.listQuery1.recAddr = this.listQuerydata.recAddr
          this.listQuery1.zipCode = null
        }
      }
    },
    buttoncancel(){
      this.$router.push({name:'OrderQuery'})
    },
    buttonprevious(){
      this.activeIndex = 0
    },
    buttonnext1(){
      if(this.listQuery1.recType === '6' && this.listQuery1.zipCode === null ){
        return this.$message.error(this.$t('item.in.bold.required'))
      }else{
        this.listQuery2.memberNo = this.memberNo
        this.btnloading = true
        goodsListCXByMember({'memberNo':this.memberNo}).then(res=>{
          this.list = res.data
          this.btnloading = false
          this.activeIndex = 2
        }).catch(err=>{
          console.error(err)
        })
      }
    },
    buttoncancel1(){
      this.$router.push({name:'OrderQuery'})
    },
    buttonprevious2(){
      if (this.companyCode === 'IN' && this.isAgent) {
        this.activeIndex = 0
      } else {
        this.activeIndex = 1
      }
    },
    buttonnext2(){
      if(this.buyQty <= 0){
        return this.$message(this.$t('leastInputANumber'))
      }
      this.activeIndex = 3
      for(let a = 0;a<this.list.length;a++){
        if(this.list[a].buyQty >0){
          this.list3.push(this.list[a])
      }
      }
      for(let i=0;i<this.list3.length;i++){
        if(this.list3[i].buyQty <= 0){
          this.list3.splice(i,1)
        }
        for(let j=i+1;j<this.list3.length;j++){
          if(this.list3[i] === this.list3[j]){
            this.order.details.splice(j,1)
            j--
          }
        }
      }
      this.listQuery3.totalLocIn = this.totalfA
      this.listQuery3.totalAmount = this.totalfA
    },
    buttoncancel2(){
      this.$router.push({name:'OrderQuery'})
    },
    buttonprevious3(){
      this.list3 = []
      this.activeIndex = 2
    },
    titlesubmit(){
      if(!this.listQuery3.payPassword){
        return this.$message.error(this.$t('please.input.your.pay.password'))
      }else{
       this.listQuery3.name  = this.listQuery1.name
        this.listQuery3.mobile  = this.listQuery1.mobile
       this.listQuery3.zipCode  = this.listQuery1.zipCode
       this.listQuery3.recType  = this.listQuery1.recType
       this.listQuery3.country  = this.listQuery1.country
       this.listQuery3.province  = this.listQuery1.province
       this.listQuery3.recAddr  = this.listQuery1.recAddr
       this.listQuery3.city  = this.listQuery1.city
       this.listQuery3.district  = this.listQuery1.district
       this.listQuery3.memberNo  = this.listQuery2.memberNo
       this.listQuery3.remark  = this.listQuery2.remark
        this.listQuery3.goodsList = this.list3
        this.btnloading = true
        saveCX({...this.listQuery3}).then(res=>{
          console.log(res)
          this.btnloading = false
          this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
          this.$router.push({name:'OrderQuery'})
        }).catch(err=>{
          this.btnloading = false
          console.error(err)
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
table {
  margin: 20px 0 20px 0px;
  width: 100%;
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  tr {
    th {
      width: 150px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid black;
    }
    td {
      width: 200px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid black;
    }
  }
  thead {
    th {
      font-size: 18px;
      border-right: 1px solid black;
      width: 400px;
    }
  }
  tbody {
    td {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      font-size: 14px;
      border: 1px solid black;
      width: 200px;
    }
  }
}
.account_name_css:after {
  content: 'X';
  color: #ff4949;
}
.disabled_remove_css {
  ::v-deep .el-input__inner {
    background-color: white;
    color: black;
  }
}
</style>
